const urlPath = '/mobil';

export default class URL {
  constructor(pattern) {
    this._pattern = pattern;
  }

  get pattern() {
    return `${urlPath}${this._pattern}`;
  }
  url(params) {
    let path = this._pattern;
    const parts = path.split(/(?=:)/g);

    parts.forEach((part) => {
      if (part.charAt(0) === ':') {
        const match = part.replace(':', '').replace('?', '').replace('/', '');
        let newPart = '';

        if (params[match]) {
          newPart = params[match] + '/';
        }

        path = path.replace(part, newPart);
      }
    });
    if (params?.state) {
      const { state } = params;
      path = { pathname: `${urlPath}${path}`, state };
      return path;
    }

    return `${urlPath}${path}`;
  }
}
